import React, { useState } from "react";
import { Accordion as MuiAccordion, AccordionSummary as MuiAccordionSummary, AccordionDetails as MuiAccordionDetails, AccordionActions as MuiAccordionActions, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Button } from "../Button/Button";
import { v4 } from "uuid";
export function Accordion(props) {
    const { actions, defaultExpanded = true, details, summary, title } = props;
    const id = props.id ?? v4();
    const [expanded, setExpanded] = useState(defaultExpanded);
    const handleChange = () => {
        setExpanded(!expanded);
    };
    const ExpandButton = React.createElement(Button, { iconButton: true, startIcon: React.createElement(ExpandMoreIcon, null), variant: "plain", rounded: true, "aria-label": expanded ? "Collapse" : "Expand" });
    const summaryId = `${id}${title ? `-${title}` : ""}`;
    return (React.createElement(MuiAccordion, { id: id, defaultExpanded: defaultExpanded, expanded: expanded, onChange: handleChange, className: props.className, style: props.style, square: true, sx: ({ palette }) => ({ padding: "2px 0", boxShadow: "0", border: `1px solid ${palette.border.main}`, margin: "0px!important" }) },
        React.createElement(MuiAccordionSummary, { "aria-controls": `${summaryId}-content`, id: `${summaryId}-header`, expandIcon: ExpandButton, sx: ({ palette }) => ({
                flexDirection: "row-reverse",
                alignItems: "center",
                ...(expanded
                    ? {
                        boxShadow: `0 2px 4px -1px ${palette.border.main}`,
                        borderBottom: `1px solid ${palette.border.main}`
                    }
                    : {})
            }) },
            title && React.createElement(Typography, { sx: ({ typography }) => ({ margin: "0px 5px", fontSize: typography.pxToRem(18), fontWeight: "600", alignSelf: "center" }) }, title),
            summary),
        React.createElement(MuiAccordionDetails, null, details),
        React.createElement(MuiAccordionActions, { disableSpacing: true }, actions)));
}
